import { Component } from '@angular/core';
import { OcrService } from '../../services/ocr.service';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-ocr-control',
  templateUrl: './ocr-control.component.html',
  styleUrls: ['./ocr-control.component.scss']
})
export class OcrControlComponent {
  isCopied: boolean;
  ocrCtrl: FormControl;
  ocrText: string;
  constructor(private ocrService: OcrService) {
    this.ocrCtrl = new FormControl();
  }

  fileChange(event) {
    const fileList: FileList = event.target.files;
    if (fileList.length > 0) {
      this.isCopied = false;
      const file: File = fileList[0];
      const formData: FormData = new FormData();
      formData.append('file', file, file.name);
      this.ocrService.processOcr(formData).subscribe(val => {
        if (val.success) {
          this.ocrCtrl.setValue(val.ocrText, { emitEvent: false });
          this.ocrText = val.ocrText;
        }
      });
    }
  }
}
